export default "__VITE_ASSET__2d82e9cc__"